import { useAuthContext } from "src/auth/AuthContext";
import { expenseService } from '@/service/PartnerExpenseService';
import ExpensesForm from "./ExpensesForm";

const ExpensesAdd = () => {
    const { user } = useAuthContext();
    return <ExpensesForm expenseId={-1} organizationId={user.data.organizationId} onSubmit={(ps) => expenseService.add(ps)} header='Neue Ausgabe' />
}

export default ExpensesAdd